import React, { memo } from 'react'
import { formatCurrency } from 'utils/formatCurrency'
import { formatUTCDate } from 'utils/formatDatetime'
import { yesOrNo } from 'utils/formatText'
import InsuranceSection from './InsuranceSection'

interface IDishonestyCoverageProps {
  coverageAmount?: string
  expirationDate?: string
  isTransfixAsHolder?: boolean
  contactInfo?: {
    email?: string
    phone?: string
    fax?: string
  }
}
const DishonestyCoverage: React.FunctionComponent<IDishonestyCoverageProps> = memo(
  ({ contactInfo, coverageAmount, expirationDate, isTransfixAsHolder }) => {
    const { email, fax, phone } = contactInfo || {}
    return (
      <InsuranceSection
        title='Dishonesty Coverage'
        rows={[
          [
            {
              label: 'Dishonesty Coverage Amount',
              value: formatCurrency(coverageAmount),
            },
            { label: 'Expiration Date', value: formatUTCDate(expirationDate) },
          ],
          [
            { label: 'Insurance Email', value: email },
            { label: 'Transfix as holder', value: yesOrNo(isTransfixAsHolder) },
          ],
          [{ label: 'Insurance Phone', value: phone }],
          [{ label: 'Insurance Fax', value: fax }],
        ]}
      />
    )
  }
)

export default DishonestyCoverage
